module.exports = __webpack_public_path__ + "static/media/Q3-8.0f979045.jpg";